import '../css/index.css';
import { tns } from "../../node_modules/tiny-slider/src/tiny-slider"

(function() {
    const heroSpacer = document.querySelector('.hero__spacer');
    const adminMobileSize = 46;
    const adminDesktopSize = 32;
    let adminbar = 0;

    function exitsViewport(element) {
        const rect = element.getBoundingClientRect();

        // if width is smaller than 783 we are on mobile admin bar. 
        window.innerWidth >= 783 ?
        adminbar = adminDesktopSize :
        adminbar = adminMobileSize;

        return (
            rect.bottom >= adminbar 
        );
    }
    
    // Add header class on scroll 
    let scrollpos = window.scrollY

    const header = document.querySelector(".navigation")
    const scrollChange = 1

    const add_class_on_scroll = () => header.classList.add("is-scroll")
    const remove_class_on_scroll = () => header.classList.remove("is-scroll")

    window.addEventListener('scroll', function() { 
    scrollpos = window.scrollY;

    if (scrollpos >= scrollChange) { add_class_on_scroll() }
    else { remove_class_on_scroll() }

    })


    //nav menu
    const ham = document.querySelector('.navigation__container__ham');
    ham.addEventListener('click', function(){
        document.querySelector('.navigation').classList.toggle('nav-visible');
        this.classList.toggle('open');
    })
    
    const animateItems = document.querySelectorAll('.fade-up');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            entry.target.classList.toggle("animate", entry.isIntersecting);
            if(entry.isIntersecting) observer.unobserve(entry.target);

        })
    },
    {
        threshold: 0.4,
    }
    );
    animateItems.forEach(entry => {
        observer.observe(entry);
    })

    // Home Slideshow
    if(document.querySelector('body').classList.contains('home')){
        const heroObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                entry.target.classList.toggle("animate", entry.isIntersecting);
                if(entry.isIntersecting) observer.unobserve(entry.target);

            })
        },
        {
            threshold: 0,
        }
        );
        
        heroObserver.observe(heroSpacer);
    }

    const slider = document.querySelectorAll('.slider')
    slider.forEach(function (el) {
        const tnsSlider = tns({
          container: el,
          mode: 'gallery',
          items: 1,
          slideBy: 'page',
          autoplay: true,
          lazyload: true,
          speed: 500,
          controls: true,
          controlsText: [
            '<span class="slider-nav prev-arrow"></span>', 
            '<span class="slider-nav next-arrow"></span>'
            ],
          nav: false,
          autoplayButton: false
        });
        /** delay play for home page */
        if(document.querySelector('body').classList.contains('home')){
            tnsSlider.pause();
            setTimeout(() => {
                tnsSlider.play();
            }, "3000")

        // update nav colour based on slide dark_nav value
        var navColour = function () {
            const activeSlide = document.querySelector('.tns-slide-active');

            if(activeSlide && activeSlide.classList.contains('dark-nav')) {
                document.querySelector('.navigation').classList.add('dark-nav');
            } else {
                document.querySelector('.navigation').classList.remove('dark-nav');
            }
        }

        // call navColour function on page load to check the first slide
        navColour();
            
        // bind function to event
        tnsSlider.events.on('transitionStart', navColour);
        }

    });

    

    //Counter for single work page
    const workSlider = document.querySelectorAll('.work-slider')
    workSlider.forEach(function (el) {
        const tnsWorkSlider = tns({
          container: el,
          mode: 'gallery',
          items: 1,
          slideBy: 'page',
          autoplay: true,
          lazyload: true,
          speed: 500,
          controls: true,
          controlsText: [
            '<span class="slider-nav prev-arrow"></span>', 
            '<span class="slider-nav next-arrow"></span>'
            ],
          nav: false,
          autoplayButton: false
        });
            if(document.querySelector('body').classList.contains('single-work')){
                let info = tnsWorkSlider.getInfo();

                const counterCurrent = document.querySelector('.work-current'), 
                counterTotal = document.querySelector('.work-total'); 
                if(counterCurrent != null){
                    counterCurrent.innerHTML = '0'+info.displayIndex;
                }
                if(counterTotal != null){
                    counterTotal.innerHTML = ' / 0'+info.slideCount;
                }
                ;

                var customizedFunction = function (info, eventName) {
                if(counterCurrent != null){
                    counterCurrent.innerHTML = '0'+info.displayIndex;
                }
                }

                // bind function to event
                tnsWorkSlider.events.on('indexChanged', customizedFunction);

            }
    });

    //Other Work slider
    //Counter for single work page
    // const otherWorkSlider = document.querySelectorAll('.slider--other-works')
    // otherWorkSlider.forEach(function (el) {
    //     const tnsOtherWorkSlider = tns({
    //       container: el,
    //       mode: 'carousel',
    //       items: 2,
    //       center: true,
    //       startIndex: 1,
    //       loop: false,
    //       slideBy: 'page',
    //       autoplay: false,
    //       rewind: true,
    //       lazyload: true,
    //       gutter: 8,
    //       fixedWidth: 320,
    //       speed: 300,
    //       controls: false,
    //       nav: false,
    //       autoplayButton: false,
    //       mouseDrag: true,
    //       responsive: {
    //         768:{
    //             disable: true
    //         }

    //       }
    //     });

    // });


    if(document.querySelector('.home')){
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        } else {
            window.onbeforeunload = function () {
                window.scrollTo(0, 0);
            }
        }
    setTimeout(() => {
        document.querySelector('.hero__inner').classList.add('init');
    }, "750");
    setTimeout(() => {
        setTimeout(() => {
            document.querySelector('body').classList.add('loaded');       
        }, "500");
        document.querySelector('.hero').classList.add('icon__logo-full--green');
        document.querySelector('.loader').classList.add('loaded');  
      }, "2500");
    };
      


    function onImagesLoaded(container, event) {
        const images = container.getElementsByTagName("img");
        let loaded = images.length;
        for (var i = 0; i < images.length; i++) {
            if (images[i].complete) {
                loaded--;
            }
            else {
                images[i].addEventListener("load", function() {
                    loaded--;
                    if (loaded == 0) {
                        event();
                    }
                });
            }
            if (loaded == 0) {
                event();
            }
        }
    }
    
    const container = document.querySelector("#tns1");

    if(document.querySelector('.home'))
    setTimeout(() => {
        onImagesLoaded(container, function() {
            // console.log("All images loaded");
            document.querySelector('.loader').classList.add('loaded');
            document.querySelector('body').classList.add('loaded'); 
            
        });
      }, "4000");
   

    // Read more toggle 
    // 
    const readMore = document.querySelectorAll('.read-more');
    readMore.forEach(function (el) {
        el.addEventListener('click', function(){
        el.previousSibling.classList.toggle('hidden');
        el.textContent == 'Read More'?
        el.textContent = el.textContent.replace('Read More', "Show Less"):
        el.textContent = el.textContent.replace('Show Less', "Read More");
        })
    })
    // FAQ expanders 
    // 
    const faq = document.querySelectorAll('.faq-question');
    faq.forEach(function (el) {
        el.addEventListener('click', function(){
           el.nextElementSibling.classList.toggle('hidden');
           el.classList.toggle('open');
        // el.textContent == 'Read More'?
        // el.textContent = el.textContent.replace('Read More', "Show Less"):
        // el.textContent = el.textContent.replace('Show Less', "Read More");
        })
    })

    // Content edit tweak 
    const smallText = document.querySelectorAll('.flex-block__text-wrap h6');
    smallText.forEach(function (el) {
       // console.log(el);
        el.outerHTML = "<p class='text-sm'>" + el.innerHTML + "</p>" ;

    }) 

    // Work Filter
    // 
    // Get the elements
const filterMainBtn = document.querySelector('.filter-link'),
filterBtnWrap = document.querySelector('.filter-terms'),
filterBtn = document.querySelectorAll('.filter-term'),
downBtn = document.querySelector('.down-arrow-icon');

// Toggle the visibility of the filter dropdown and the down arrow icon when the main filter button is clicked
if (filterMainBtn) {
filterMainBtn.addEventListener('click', function() {
    filterBtnWrap.classList.toggle('invisible');  // Toggle dropdown visibility
    downBtn.classList.toggle('inverse');  // Toggle arrow icon (inverse rotation)
});
}

// Event listener for each filter option
filterBtn.forEach(function(el) {
el.addEventListener('click', function() {
    const filterName = 'work_category-' + el.dataset.category;
    const works = document.querySelectorAll('.work-item');
    
    // Find the selected-term placeholder
    const selectedTerm = document.querySelector('.selected-term');
    
    // Update the selected-term text with the clicked filter's text
    selectedTerm.textContent = el.textContent.trim();

    // Remove 'filter-term--active' class from all filter buttons
    filterBtn.forEach(button => button.classList.remove('filter-term--active'));

    // Add 'filter-term--active' to the clicked filter button
    el.classList.add('filter-term--active');

    // Filter the works
    works.forEach((el) => {
        if (filterName == 'work_category-all') {
            el.classList.add('work-item--hidden');
            setTimeout(() => {
                el.classList.remove('work-item--hidden--for-real');
            }, 400);
            setTimeout(() => {
                el.classList.remove('work-item--hidden');
            }, 600);
        } else {
            el.classList.add('work-item--hidden');
            setTimeout(() => {
                el.classList.remove('work-item--hidden--for-real');
                if (!el.classList.contains(filterName)) {
                    el.classList.add('work-item--hidden--for-real');
                }
            }, 400);
            setTimeout(() => {
                el.classList.remove('work-item--hidden');
            }, 600);
        }
    });

    // Hide the dropdown after selecting a filter
    filterBtnWrap.classList.add('invisible');
    downBtn.classList.remove('inverse');  // Reset the arrow icon to its original state
});
});
   
    
    /** Video Placeholder Image and play button */

//   if (isArchive.length > 0) {
    var startVideo = function startVideo(c) {
      str[c].onclick = function () {
        for (i = 0; i < pyr.length; i++) {
          pyr[i].src = pyr[i].src.replace('&autoplay=1', '');
          str[i].classList.remove('hidden');
        }

        pyr[c].src = pyr[c].src + '&autoplay=1';
        str[c].classList.add('hidden');
      };
    };

    // only run it on archive page
    var str = document.querySelectorAll('.starter'),
        pyr = document.querySelectorAll('.player'),
        c,
        i;

    for (c = 0; c < str.length; c++) {
      str[c].classList.remove('hidden');
      str[c].addEventListener('click', startVideo(c), false);
    }
//   }

    /**  Single Work page */
    if(document.body.classList.contains('single-work')){

        let textArea = document.querySelector(".work-information"),
        imgArea = document.querySelector(".work-images");
        imgArea.style.height = textArea.offsetHeight + "px"
    
        const myObserver = new ResizeObserver(entries => {
        // this will get called whenever div dimension changes
            entries.forEach(entry => {
            imgArea.style.height = textArea.offsetHeight + "px"
            });
        });
        
        // start listening to changes
        myObserver.observe(textArea);
             
    }
    

    /** Contact Form Get Last Page  */

    let path = window.location.pathname,
    contactPath = '/contact',
    baseUrl = window.location.origin
    // remove the trailing pathname slash if present
    path.endsWith('/') ?
        path = path.slice(0, -1):
        path;

    if ((path != contactPath) && (localStorage.getItem('workUrl') != null)){
        localStorage.clear()
    }

    let links = document.querySelectorAll('a[href="'+baseUrl+contactPath+'/"], a[href="'+baseUrl+contactPath+'"]')
    
    links.forEach((link) => {
        link.addEventListener('click', () => {
            let workUrl = localStorage.setItem('workUrl', path)
        })
      });

     
    
    if(path == contactPath && localStorage.getItem('workUrl')){
        function waitForElm(selector) {
            return new Promise(resolve => {
                if (document.querySelector(selector)) {
                    return resolve(document.querySelector(selector));
                }
        
                const observer = new MutationObserver(mutations => {
                    if (document.querySelector(selector)) {
                        resolve(document.querySelector(selector));
                        observer.disconnect();
                    }
                });
        
                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            });
        }
        waitForElm('#nf-field-1').then((elm) => {
            let form = document.querySelector('#nf-form-1-cont')
            let hiddenField = document.querySelector('#nf-field-13')
            value = hiddenField.value = localStorage.getItem('workUrl')
            value = value.substring(value.indexOf('_') + 7);
            hiddenField.value = value
            
            let jewelType =  document.getElementById('nf-field-10').options;
            for(var i = 0; i < jewelType.length; i++)
            {    if( jewelType[i].value === value )
                {   
                    jQuery( '#nf-field-10').val( value ).trigger( 'change' ); 
                    break;        
                }    
            }    

        });
    }
    

})();


